// ─────────────────────────────────────────────────────────────
// Helpers compartidos del módulo de Liquidación de Clientes
// ─────────────────────────────────────────────────────────────

export const formatCurrency = (v) =>
  v != null && !isNaN(v)
    ? `$${Number(v).toLocaleString('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
    : '—';

export const formatDate = (d) => {
  if (!d) return '—';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return '—';
  return dt.toLocaleDateString('es-CO', { year: 'numeric', month: '2-digit', day: '2-digit' });
};

export const formatDateTime = (d) => {
  if (!d) return '—';
  const dt = new Date(d);
  if (isNaN(dt.getTime())) return '—';
  return dt.toLocaleString('es-CO', {
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
  });
};

export const formatTime = (d) => {
  if (!d) return '—';
  return new Date(d).toLocaleTimeString('es-CO', { hour: '2-digit', minute: '2-digit' });
};

export const fmtNum = (n) => Number(n).toFixed(2);

export const todayStr = () => new Date().toISOString().slice(0, 10);

/** Suma cantidades de items en una entrega */
export const sumCantidad = (items) =>
  (items || []).reduce((s, i) => s + (i.cantidad || 0), 0);

/** Suma subtotales de items en una entrega */
export const sumSubtotal = (items) =>
  (items || []).reduce((s, i) => s + Number(i.subtotal || 0), 0);
